const env = process.env.ENVIRONMENT !== 'PDN' ? 'DEV' : 'PDN'

let url = {
  DEV: 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol',
  PDN: 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol',
}[env]

export const SAVE_IMAGE =
  url + '/competition/api/v1/competition-participation-image'

//register
export const preRegisterUser = url + '/register/api/v1/user'
export const registerUser = url + '/register/api/v1/register'
export const confirmUserCode = url + '/register/api/v1/user/confirmation'
export const resendCode = url + '/register/api/v1/user/resend-code'
export const parentConfirmation =
  url + '/register/api/v1/user/parent-confirmation'
export const infoUser = url + '/register/api/v1/user?email='
export const stateUser = url + '/register/api/v1/status'
export const parentResentConfirmation =
  url + '/register/api/v1/user/resend-parent-request'

//authentication
export const authentication = url + '/authentication/api/v1/auth'
export const recoverPass = url + '/recovery/api/v1/recovery'
export const restorePassToken = url + '/recovery/api/v1/change'
export const restorePass = url + '/recovery/api/v1/change-recovery'
export const getDataPolicy = url + '/account/api/v1/data-policy'
//account
export const accountInfo = url + '/account/api/v1/user'
export const accountUpdate = url + '/account/api/v1/account'
export const pictureUpdate = url + '/account/api/v1/picture'
export const otpSend = url + '/otp/api/v1/otp'
export const otpValidate = url + '/otp/api/v1/verify-otp'

//notifications
export const userNotification =
  url + '/user-notification/api/v1/setup/notification/horoscope'
export const userNotificationSettigns =
  url + '/user-notification/api/v1/notification'
export const notificationSettingsState =
  url + '/user-notification/api/v1/setup/notification'
export const listNotifications = url + '/user-notification/api/v1/notifications'

//concourse
export const getConcourseInfo = url + '/competition/api/v1/concourse'
export const getConcourseWinners = url + '/competition/api/v1/competition'
export const getConcourseState =
  url + '/competition/api/v1/competition-information-closed'
export const postConcourseParticipation =
  url + '/competition/api/v1/competition-participation'
export const getConcourseParticipation =
  url + '/competition/api/v1/competition-participation/'
export const postRedeemCompetition =
  url + '/redemption/api/v1/redeem-competitions'
export const getAccumulationsTotal =
  url + '/competition/api/v1/get-accumulation-total/'

// Activity type Game
export const getTop = url + '/competition/api/v1/top-game'
export const getTokenGame = url + '/competition/api/v1/get-token-game'
export const postGameParticipationRedeem =
  url + '/competition/api/v1/game-participation-redeem'
export const postGameParticipationSave =
  url + '/competition/api/v1/game-participation-save'
export const getGameStorage = url + '/competition/api/v1/life'
export const postGameStorage = url + '/competition/api/v1/life'

//products
export const summaryProductsResults = url + '/rating/api/v1/review'
export const qualifyProduct = url + '/rating/api/v1/rate-product'
export const commentProduct = url + '/rating/api/v1/review-product'
export const listAverage = url + '/rating/api/v1/products'

//consulting
export const commentsByTopic = url + '/consulting/api/v1/consulting'
export const likesOrDislike = url + '/consulting/api/v1/consultation'

//contact
export const sendQuestion = url + '/notification/api/v1/contact'

//magazin
export const postContent = url + '/content/api/v1/file'
export const postContentText = url + '/content/api/v1/text'
export const getCommments = url + '/content/api/v1/commentaries'
export const setCommments = url + '/content/api/v1/comment'
export const setCommmentsReport = url + '/content/api/v1/comment/report'
export const setLikes = url + '/content/api/v1/rate'
export const getLikeById = url + '/content/api/v1/rating'
export const getLikesArticles = url + '/content/api/v1/ratings'

//My points
export const postMyKeys = url + '/accumulation/api/v1/key'
export const getPrices = url + '/redemption/api/v1/prizes'

export const getAccumulations = url + '/accumulation/api/v1/accumulations'

//Call center
export const getCounsulting = url + '/consulting/api/v1/call-center/consulting'
export const changeSpecialist =
  url + '/consulting/api/v1/call-center/change-specialist'
export const closeQuestion =
  url + '/consulting/api/v1/call-center/close-consultation'
export const getHistory =
  url + '/consulting/api/v1/call-center/consultation-history'

//Websocket
export const webSocketEndPoint = url + '/user-notification/nol-websocket'

// Get ip Address
export const GET_IP_ADDRESS = 'https://jsonip.com/'

//Forum protectores
export const getForumsByConcourse =
  url + '/competition/api/v1/forum/getForumsByConcourseId'
export const getRepliesByForum =
  url + '/competition/api/v1/forum/getRepliesByForumId'
export const replyForum = url + '/competition/api/v1/forum/saveForumReply'
export const saveLikeByCommentId =
  url + '/competition/api/v1/forum/SaveLikeCommentary'

//// LIFE
export const url_getlife = url + '/competition/api/v1/life/'
export const url_consumelife = url + '/competition/api/v1/use-life/'
